export const perPageValue = ["5", "10", "15", "20", "25"];
